import { Component, computed, inject, input, Signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';

@Component({
  selector: 'app-faq',
  imports: [
    TranslatePipe,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
  ],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  translationPrefix = input.required<string>();
  faqData: Signal<FaqDataItem[]> = computed(() => this.getFaqData());

  private translate = inject(TranslateService);

  private getFaqData(): FaqDataItem[] {
    let faqData: FaqDataItem[] = [];
    FAQ_KEYS.forEach(key => {
      faqData.push({
        question: this.getFaqQuestion(key),
        answer: this.getFaqAnswer(key),
        additionalList: this.getAdditionalData(key),
      });
    });
    return faqData;
  }
  private faqAdditionalData: Partial<Record<FaqKeyValue, string[]>> = {
    dataFormat: ['0', '1', '2'],
  };

  private getFaqQuestion(item: string) {
    return this.translate.instant(
      this.translationPrefix() + 'questions.' + item + '.question'
    );
  }

  private getFaqAnswer(item: string) {
    return this.translate.instant(
      this.translationPrefix() + 'questions.' + item + '.answer'
    );
  }

  private getAdditionalData(item: FaqKeyValue): string[] {
    let additionalData: string[] = [];
    if (this.faqAdditionalData[item]) {
      this.faqAdditionalData[item]?.forEach(key => {
        additionalData.push(
          this.translate.instant(
            this.translationPrefix() +
              'questions.' +
              item +
              '.additionalList.' +
              key
          )
        );
      });
    }
    return additionalData;
  }
}

export const FAQ_KEYS = [
  'supportedFormat',
  'mandatoryCols',
  'dataFormat',
  'update',
  'failed',
] as const;

export type FaqKeyValue = (typeof FAQ_KEYS)[number];

export type FaqDataItem = {
  question: string;
  answer: string;
  additionalList?: string[];
};
